@import 'igws-multi-link.less';

:host(.mobile) ::slotted(igws-cta) {
  padding-left: 10px;
  padding-right: 0;
}
:host(.arrow--light),
:host(.arrow--dark) {
  ::slotted(igws-cta) {
    padding: 0 0 0 10px;
  }
}

/* tablet breakpoint */
@media (max-width: @medium-breakpoint) {
  :host {
    ::slotted(igws-cta) {
      padding-left: 10px;
      padding-right: 0;
    }
  }
}
